import React, { useRef } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import SVG from 'components/renderSvg';
import rightArrow from 'media/svgs/right-arrow.svg';
import leftArrow from 'media/svgs/left-arrow.svg';
import getBaseUrl from 'libs/baseUrl';

const responsive = {
  largeDesktop: {
    breakpoint: { max: 3000, min: 1200 },
    items: 4.5,
  },
  desktop: {
    breakpoint: { max: 1199, min: 992 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 991, min: 768 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 767, min: 0 },
    items: 1,
  },
};

const SlideItem = ({ item }) => {
  const baseUrl = getBaseUrl();
  const handleClick = () => {
    if (item?.redirectionLink) {
      window.open(item.redirectionLink, '_blank');
    }
  };

  const extractBaseUrlWithoutPath = url => {
    try {
      const { protocol, host } = new URL(url);
      return `${protocol}//${host}`;
    } catch (error) {
      console.error('Invalid URL:', url);
      return null;
    }
  };

  const url = extractBaseUrlWithoutPath(baseUrl);

  return (
    <div
      className='m-2 cursor-pointer rounded-lg bg-gray-100 p-4 text-center shadow-md'
      onClick={handleClick}
    >
      <div className='flex justify-center'>
        <img
          src={`${url}${item.path}`}
          alt={item.label}
          className='size-40 rounded-full object-cover'
        />
      </div>

      <h3 className='mt-4 text-lg font-semibold text-gray-700'>
        {item?.label}
      </h3>
    </div>
  );
};

const SliderExample = ({ data }) => {
  const carouselRef = useRef();

  const goToPrevious = () => {
    if (carouselRef?.current) {
      carouselRef?.current?.previous();
    }
  };

  const goToNext = () => {
    if (carouselRef?.current) {
      carouselRef?.current?.next();
    }
  };

  return (
    <div className='relative p-6'>
      <div className='flex items-center justify-between pb-1 pl-2'>
        <p className='text-[22px] font-medium'>Product Details</p>
        <div className='flex items-center space-x-6'>
          <button
            onClick={goToPrevious}
            aria-label='Previous'
            className=' flex items-center justify-center rounded-[7px] border border-solid p-1 shadow-lg'
          >
            <SVG icon={leftArrow} />
          </button>
          <button
            onClick={goToNext}
            aria-label='Next'
            className='flex  items-center justify-center rounded-[7px] border border-solid p-1  shadow-lg'
          >
            <SVG icon={rightArrow} />
          </button>
        </div>
      </div>

      <Carousel
        ref={carouselRef}
        responsive={responsive}
        infinite={false}
        autoPlay={false}
        containerClass='carousel-container'
        itemClass='carousel-item-padding-40-px'
        arrows={false} // Hide default arrows
      >
        {data?.map(item => (
          <SlideItem key={item?.name} item={item} />
        ))}
      </Carousel>
    </div>
  );
};

export default SliderExample;
